// extracted by mini-css-extract-plugin
module.exports = {"container":"_2JPtnA-STxMFWPARYYHI45"};